import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import App from 'App';
import CarTypePage from 'pages/CarType';
import BudgetPage from 'pages/Budget';
import NeedCarPage from 'pages/NeedCar';
import PhonePage from 'pages/Phone';
import NamePage from 'pages/Name';
import BirthdayPage from 'pages/Birthday';
import GenderPage from 'pages/Gender';
import WorkingPage from 'pages/Working';
import ExperiencePage from 'pages/Experience';
import MounthlyPage from 'pages/Mounthly';
import MounthlyDownPage from 'pages/Mounthly/Down';
import ConfirmationPage from 'pages/Confirmation';
import UploadPage from 'pages/Upload';
import SearchPage from 'pages/Search';
import ApprovedPage from 'pages/Approved';
import CarPage from 'pages/CarPage';
import PaymentPage from 'pages/Payment';
import ReturnedPage from 'pages/Returned';
import SignaturePage from 'pages/Signature';
import ProfilePage from 'pages/Profile';
import ProfileCarsPage from 'pages/ProfileCars';
import DeliveryPage from 'pages/Delivery';
import AdminRestorePass from 'pages/AdminRestorePass';
import LoginAdmin from 'pages/LoginAdmin';
import CarEditorPage from 'pages/CarEditorPage';
import LoginPage from 'pages/Login';

import { URLS } from 'config';

class Routes extends React.Component {
  isLastRouteRedirect = !!localStorage.getItem('carsapp-route') ;

  lastRouteRedirect = () => {
    const deprecated = [URLS.LOGIN, URLS.PROFILE, URLS.RETURNED, URLS.PROFILECARS];
    const lastRoute = localStorage.getItem('carsapp-route');
    const localStorageData = localStorage.getItem('carsapp') ? JSON.parse(localStorage.getItem('carsapp')) : null;
    const splittedPathName = window.location.pathname && window.location.pathname.split('/').filter(el => el !== '');

    if (window.location.pathname !== URLS.BASE
      && window.location.pathname !== URLS.LOGIN
      && !localStorageData) {
      this.isLastRouteRedirect = false;

      return <Redirect to={URLS.BASE} />;
    }

    if (splittedPathName[0] === 'name' && splittedPathName[1] && splittedPathName[1] !== '') {
      this.isLastRouteRedirect = false;

      return null;
    }


    if (localStorageData
      && localStorageData.user
      && localStorageData.user.user
      && localStorageData.user.user.registrationDone
    ) {
      return <Redirect to={URLS.PROFILECARS} />;
    }

    if (
      deprecated.findIndex(el => el === lastRoute) === -1
      && window.location.pathname !== URLS.LOGIN
      && window.location.pathname !== URLS.PROFILE
      && window.location.pathname !== URLS.RETURNED
      && localStorageData
      && localStorageData.user
      && Object.keys(localStorageData.user.user).length
      && this.isLastRouteRedirect
    ) {
      this.isLastRouteRedirect = false;

      return <Redirect to={URLS.RETURNED} />;
    }


    this.isLastRouteRedirect = false;
    return null;
  }

  render() {
    return (
      <App>
        {process.env.NODE_ENV !== 'development' ? this.lastRouteRedirect() : null}
        <Switch>
          <Route path={URLS.BASE} component={CarTypePage} exact />
          <Route path={URLS.BUDGET} component={BudgetPage} />
          <Route path={URLS.NEEDCAR} component={NeedCarPage} />
          <Route path={URLS.PHONE} component={PhonePage} />
          <Route path={`${URLS.NAME}/:name?/:birthday?/:gender?`} component={NamePage} />
          <Route path={URLS.BIRTHDAY} component={BirthdayPage} />
          <Route path={URLS.GENDER} component={GenderPage} />
          <Route path={URLS.WORKING} component={WorkingPage} />
          <Route path={URLS.EXPERIENCE} component={ExperiencePage} />
          <Route path={`${URLS.MOUNTHLY}/:reject?`} component={MounthlyPage} />
          <Route path={URLS.DOWNPAYMENTS} component={MounthlyDownPage} />
          <Route path={URLS.CONFIRMATION} component={ConfirmationPage} />
          <Route path={URLS.UPLOAD} component={UploadPage} />
          <Route path={URLS.SEARCH} component={SearchPage} />
          <Route path={URLS.APPROVED} component={ApprovedPage} />
          <Route path={URLS.CAR} component={CarPage} />
          <Route path={URLS.PAYMENT} component={PaymentPage} />
          <Route path={URLS.RETURNED} component={ReturnedPage} />
          <Route path={URLS.SIGNATURE} component={SignaturePage} />
          <Route path={URLS.PROFILE} component={ProfilePage} />
          <Route path={URLS.PROFILECARS} component={ProfileCarsPage} />
          <Route path={URLS.DELIVERY} component={DeliveryPage} />
          <Route path={`${URLS.RESPASS}/:id`} component={AdminRestorePass} />
          <Route path={URLS.LOGINADMIN} component={LoginAdmin} />
          <Route path={URLS.LOGIN} component={LoginPage} />
          <Route path={URLS.CAREDITOR} component={CarEditorPage} />
          <Route component={CarTypePage} />
        </Switch>
      </App>
    );
  }
}

export default Routes;



// WEBPACK FOOTER //
// ./src/Routes.js